<template>
  <!-- モーダル -->
  <client-only>
    <Teleport to="body">
      <dialog
        ref="calendarModal"
        class="modal"
      >
        <form
          class="modal-box lg:min-w-[40rem]"
          @submit.prevent
        >
          <!-- 右上の閉じるボタン -->
          <div
            class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
            @click="closeModal"
          >
            ✕
          </div>
          <!-- モーダルのコンテンツ -->
          <div class="te-modal-body pb-[6.25rem] pt-5">
            <img
              src="~/assets/images/Te/TeCounseling/Apply/step-three.svg"
              class="mx-auto my-5"
              width="218"
              height="46"
              loading="lazy"
            >
            <div class="text-center">
              <p class="co-display-11 mb-8 font-bold">
                最後に必要事項をご記入ください
              </p>
              <p class="co-display-11 mb-10 inline-block bg-co-gray-200 p-5 text-center font-bold md:px-12 md:py-4">
                {{ dateToDateStr(appointmentDate) }} - {{ dateToHourStr(appointmentEndsAt) }}
                <span class="co-display-13 ml-3 whitespace-nowrap rounded-full bg-co-gray-600 px-2 py-1 font-bold leading-none text-white">
                  <FontAwesomeIcon
                    :icon="faClockNine"
                    class="fa-fw mr-1"
                  />最大{{ 30 * range }}分
                </span>
              </p>
            </div>

            <!-- フォーム -->
            <!-- 氏名 -->
            <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
              <label
                class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
                for="entry_last_name"
              >
                氏名
                <TeCommonBadgeRequired class="ml-2" />
              </label>
              <div class="basis-full md:basis-8/12">
                <div class="flex gap-x-4">
                  <div class="basis-6/12">
                    <input
                      id="entry_last_name"
                      v-model="lastName"
                      class="input w-full border-2 border-co-gray-300"
                      placeholder="煌木"
                      type="text"
                      required
                    >
                    <span
                      v-if="errors.last_name && errors.last_name.length !== 0"
                      class="te-invalid-feedback inline-block"
                    >
                      {{ errors.last_name.join(", ") }}
                    </span>
                  </div>
                  <div class="basis-6/12">
                    <input
                      v-model="firstName"
                      class="input w-full border-2 border-co-gray-300"
                      placeholder="太郎"
                      type="text"
                      required
                    >
                    <span
                      v-if="errors.first_name && errors.first_name.length !== 0"
                      class="te-invalid-feedback inline-block"
                    >
                      {{ errors.first_name.join(", ") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 氏名（カナ） -->
            <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
              <label
                class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
                for="entry_last_name_kana"
              >
                氏名（カナ）
                <TeCommonBadgeRequired class="ml-2" />
              </label>
              <div class="basis-full md:basis-8/12">
                <div class="flex gap-x-4">
                  <div class="basis-6/12">
                    <input
                      id="entry_last_name_kana"
                      v-model="lastNameKana"
                      placeholder="キラメキ"
                      type="text"
                      required
                      class="input w-full border-2 border-co-gray-300"
                    >
                    <span
                      v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
                      class="te-invalid-feedback inline-block"
                    >
                      {{ errors.last_name_kana.join(", ") }}
                    </span>
                  </div>
                  <div class="basis-6/12">
                    <input
                      v-model="firstNameKana"
                      placeholder="タロウ"
                      type="text"
                      required
                      class="input w-full border-2 border-co-gray-300"
                    >
                    <span
                      v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
                      class="te-invalid-feedback inline-block"
                    >
                      {{ errors.first_name_kana.join(", ") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- メールアドレス -->
            <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
              <label
                class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
                for="entry_email"
              >
                メールアドレス
                <TeCommonBadgeRequired class="ml-2" />
              </label>
              <div class="basis-full md:basis-8/12">
                <input
                  id="entry_email"
                  v-model="email"
                  placeholder="taro.kirameki@techacademy.jp"
                  type="email"
                  required
                  class="input w-full border-2 border-co-gray-300"
                >
                <span
                  v-if="errors.email && errors.email.length !== 0"
                  class="te-invalid-feedback inline-block"
                >
                  {{ errors.email.join(", ") }}
                </span>
              </div>
            </div>
            <!-- 興味のあるコース -->
            <div class="w-full border-b border-dotted border-co-gray-300 pb-8 md:px-4">
              <label
                class="mb-6 mt-8 block font-bold"
                for="entry_interested_course"
              >
                興味のあるコース（複数選択可）
                <TeCommonBadgeRequired class="ml-2" />
              </label>
              <div class="w-full">
                <div
                  v-for="interested_course_category in interestedCourseCategories"
                  class="mb-4"
                >
                  <label class="label cursor-pointer justify-start gap-x-2">
                    <input
                      :id="'interested_course_category_' + interested_course_category.id"
                      :name="'interested_course_category_' + interested_course_category.id"
                      type="checkbox"
                      class="checkbox checkbox-xs"
                      :value="interested_course_category.interested_courses.map((interested_course) => String(interested_course.id))"
                      :checked="isCategoryChecked(interested_course_category)"
                      @change="handleCategoryCheckboxChange($event, interested_course_category)"
                    >
                    <span class="label-text md:text-[1rem]">{{ interested_course_category.name }}</span>
                  </label>
                </div>
                <!-- 検討中 -->
                <div class="mb-4">
                  <label class="label cursor-pointer justify-start gap-x-2">
                    <input
                      id="checkbox-kentou"
                      name="checkbox-kentou"
                      type="checkbox"
                      value="-1"
                      class="checkbox checkbox-xs"
                      :checked="interestedCourseSelected.includes('-1')"
                      @change="handleCheckboxChange($event, -1)"
                    >
                    <span class="label-text md:text-[1rem]">その他</span>
                  </label>
                </div>
                <span
                  v-if="errors.interested_course_ids && errors.interested_course_ids.length !== 0"
                  class="te-invalid-feedback inline-block"
                >
                  {{ errors.interested_course_ids.join(", ") }}
                </span>
              </div>
            </div>
            <!-- メンターへの質問 -->
            <div class="pb-8 pt-5 md:px-4">
              <label
                class="mb-6 inline-block font-bold"
                for="entry_asking"
              >
                メンターへの質問
                <TeCommonBadgeOptional class="ml-2" />
              </label>
              <textarea
                id="entry_asking"
                v-model="asking"
                placeholder="質問したい内容をご記入ください。"
                rows="4"
                class="textarea textarea-bordered h-32 w-full border-2 border-co-gray-300"
              />
              <span
                v-if="errors.asking && errors.asking.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.asking.join(", ") }}
              </span>
            </div>

            <!-- エラーメッセージ -->
            <span
              v-if="Object.keys(errors).length !== 0"
              class="te-invalid-feedback inline-block py-2 text-center"
            >
              入力いただいた情報に誤りまたは不足があるようです。
            </span>
            <span
              v-if="applicationErrors.length !== 0"
              class="te-invalid-feedback inline-block py-2"
              v-html="applicationErrors[0]"
            />

            <!-- 注釈 -->
            <div class="co-display-14">
              このサイトはreCAPTCHAによって保護されており、Googleの<a
                href="https://policies.google.com/privacy"
                target="_blank"
              >プライバシーポリシー</a>と<a
                href="https://policies.google.com/terms"
                target="_blank"
              >利用規約</a>が適用されます。
            </div>

            <!-- モーダルフッター -->
            <div class="modal-action absolute inset-x-0 bottom-0 mt-0 flex w-full items-center justify-between border-t border-co-gray-200 p-4 backdrop-blur md:justify-around">
              <button
                type="button"
                class="co-btn-tertiary"
                @click="closeModal"
              >
                キャンセル
              </button>
              <button
                v-show="isSubmitButton"
                class="co-btn-submit !w-[10.5rem] !p-3 !text-[1rem]"
                @click="onSubmit"
              >
                次へ進む
              </button>
              <!-- ローディング中アラート -->
              <div v-show="isSubmitLoading">
                <div class="flex flex-col items-center justify-center md:flex-row">
                  <FontAwesomeIcon
                    :icon="faSpinner"
                    class="fa-fw fa-spin mr-1 text-[1.5rem]"
                  />
                  <p class="co-display-13 mt-2 text-center md:ml-3 md:mt-0">
                    日程を確定させております。
                    <br class="md:hidden">
                    そのままお待ちください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- モーダルの外側をクリックしたら閉じる -->
        <button
          class="modal-backdrop"
          @click="closeModal"
        >
          close
        </button>
      </dialog>
    </Teleport>
  </client-only>
</template>

<script lang="ts">
import { postTrialMiniCourseSchedule } from '~/utility/fetchAPI'
import validatePostTrialMiniCourseScheduleMatching from '~/utility/validation/validatePostTrialMiniCourseScheduleMatching'
import { daysOfWeek } from '~/utility/utility'

import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'
import TeCommonBadgeOptional from '~/components/Te/TeCommon/Badge/TeCommonBadgeOptional/TeCommonBadgeOptional.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faClockNine } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faSpinner } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Data {
  email: string
  lastName: string
  lastNameKana: string
  firstName: string
  firstNameKana: string
  interestedCourseSelected: string[]
  asking: string
  errors: any
  applicationErrors: string[]
  isSubmitButton: boolean // 次へ進むボタン
  isSubmitLoading: boolean // ローディング中アラート
}

interface Methods {
  onSubmit: () => void
  dateToDateStr: (date: Date) => string
  dateToHourStr: (date: Date) => string
}

interface Computed {
  interestedCourseCategories: any
  appointmentBeginsAt: Date | null
  appointmentEndsAt: Date | null
}

interface Props {
  appointmentForm: any
  appointmentDate: Date
  range: number
  purpose: string
  motivation: number
  age: number
  gender: number
  pageUrl: string
}

const options = {
  async setup() {

    // モーダルの開閉制御
    const calendarModal = ref<HTMLDialogElement | null>(null)

    const showModal = () => {
      if (calendarModal.value) {
        calendarModal.value.showModal()
      }
    }

    const closeModal = () => {
      if (calendarModal.value) {
        calendarModal.value.close()
      }
    }

    return {
      calendarModal,
      showModal,
      closeModal,
      faClockNine,
      faSpinner,
    }
  },
  props: {
    appointmentForm: {
      default: null,
    },
    appointmentDate: {
      default: null,
    },
    range: {
      default: 1,
    },
    purpose: {
      default: '',
    },
    motivation: {
      default: 0,
    },
    age: {
      default: 0,
    },
    gender: {
      default: 0,
    },
    pageUrl: {
      default: '',
    },
  },
  data() {
    return {
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      email: '',
      interestedCourseSelected: [],
      checkedCategories: [],
      asking: '',
      errors: {},
      applicationErrors: [],
      isSubmitButton: true, // 次へ進むボタン
      isSubmitLoading: false, // ローディング中アラート
    }
  },
  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      // 何もしない
    }
  },
  computed: {
    interestedCourseCategories() {
      if (!this.appointmentForm) return [{ id: '0', title: '読み込み中' }]
      return this.appointmentForm.interested_course_collection
    },
    appointmentBeginsAt() {
      if (!this.appointmentDate) return null
      return new Date(this.appointmentDate)
    },
    appointmentEndsAt() {
      if (!this.appointmentDate) return null
      const date = new Date(this.appointmentDate)
      date.setMinutes(date.getMinutes() + 30 * this.range)
      return date
    },
  },
  beforeDestroy() {
    this.$recaptcha.destroy()
  },
  methods: {
    async onSubmit() {
      this.errors = {}
      this.applicationErrors = []
      const token: string = await this.$recaptcha.execute('trialEntry')
      const body: any = {
        trial_appointment_account_form: {
          appointment_form: {
            begins_at: `${this.appointmentDate}`,
            interested_course_ids: this.interestedCourseSelected,
            asking: this.asking,
            range: this.range,
            purpose: this.purpose,
            motivation: this.motivation,
            age: this.age,
            gender: this.gender,
          },
          trial_entry: {
            last_name: this.lastName,
            first_name: this.firstName,
            last_name_kana: this.lastNameKana,
            first_name_kana: this.firstNameKana,
            email: this.email,
            marketing_params: this.$marketingParams.get(),
          },
          page_url: this.pageUrl,
        },
        recaptcha_token: token,
      }
      validatePostTrialMiniCourseScheduleMatching(body)
        .then(() => {
          postTrialMiniCourseSchedule(this.$api, 'htmlcss-trial', body)
            .then((response) => {
              this.$marketingParams.remove()
              if (!this.pageUrl) {
                if (window.top !== null) {
                  window.top.location.href = `/lp-htmlcss-trial-schedule/completed`
                } else {
                  window.location.href = `/lp-htmlcss-trial-schedule/completed`
                }
              } else if (window.top !== null) {
                window.top.location.href = `/lp-htmlcss-trial-schedule/completed?token=${response.token}&id=${response.id}`
              } else {
                window.location.href = `/lp-htmlcss-trial-schedule/completed?token=${response.token}&id=${response.id}`
              }
            })
            .catch((errors: any) => {
              this.applicationErrors = errors?.response?.data?.errors
              // 次へ進むボタンを表示してローディングを非表示に
              this.isSubmitButton = true
              this.isSubmitLoading = false
            })
        })
        .catch((errors: any) => {
          this.errors = errors
          // 次へ進むボタンを表示してローディングを非表示に
          this.isSubmitButton = true
          this.isSubmitLoading = false
        })

      // 次へ進むボタンを非表示にしてローディングを表示
      this.isSubmitButton = false
      this.isSubmitLoading = true
    },
    dateToDateStr(date) {
      if (!date) return '-/- (-)'
      return `${date.getMonth() + 1}/${date.getDate()} (${daysOfWeek(
        date
      )}) ${String(date.getHours()).padStart(1, '0')}:${String(
        date.getMinutes()
      ).padStart(2, '0')}`
    },
    dateToHourStr(date) {
      if (!date) return '-:-'
      return `${String(date.getHours()).padStart(1, '0')}:${String(
        date.getMinutes()
      ).padStart(2, '0')}`
    },
    // カテゴリのチェックボックスの変更イベント
    handleCategoryCheckboxChange(event: Event, category: { id: number, interested_courses: { id: number }[] }) {
      const target = event.target as HTMLInputElement
      const categoryId = category.id
      const courseIds = category.interested_courses.map(course => String(course.id))

      if (target.checked) {
        // チェックボックスがチェックされた場合
        if (!this.checkedCategories.includes(categoryId)) {
          this.checkedCategories.push(categoryId)
        }
        this.interestedCourseSelected.push(...courseIds.filter(id => !this.interestedCourseSelected.includes(id)))
      } else {
        // チェックボックスがチェック解除された場合
        this.checkedCategories = this.checkedCategories.filter(id => id !== categoryId)
        this.interestedCourseSelected = this.interestedCourseSelected.filter(id => !courseIds.includes(id))
      }
    },
    // その他のチェックボックスの変更イベント
    handleCheckboxChange(event: Event, courseId: number) {
      const target = event.target as HTMLInputElement
      const value = String(courseId)

      if (target.checked) {
        // チェックボックスがチェックされた場合
        if (!this.interestedCourseSelected.includes(value)) {
          this.interestedCourseSelected.push(value)
        }
      } else {
        // チェックボックスがチェック解除された場合
        this.interestedCourseSelected = this.interestedCourseSelected.filter(id => id !== value)
      }
    },
    // チェック状態を返す
    isCategoryChecked(category: { id: number, interested_courses: { id: number }[] }) {
      return this.checkedCategories.includes(category.id)
    },
  },
  components: {
    TeCommonBadgeRequired,
    TeCommonBadgeOptional,
    FontAwesomeIcon,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
